/**
 * Barras horizontales de agregado para la Pantalla (legibles a 6 m, C7: solo
 * agregados, nunca por persona). Compartidas por las proyecciones del registro
 * de primitivas y por el desglose genérico por grupo.
 */
export function Barras({
  titulo,
  filas,
  total,
}: {
  titulo: string;
  filas: { etiqueta: string; n: number }[];
  total: number;
}) {
  const orden = [...filas].sort((a, b) => b.n - a.n);
  const max = Math.max(1, ...orden.map((f) => f.n));

  return (
    <section className="mt-10 w-full max-w-3xl text-left">
      <h2 className="mb-4 text-center font-sans text-lg uppercase tracking-wide text-content-muted">
        {titulo}
      </h2>
      <ul className="flex flex-col gap-3">
        {orden.map((f) => {
          const pct = total > 0 ? Math.round((f.n / total) * 100) : 0;
          return (
            <li key={f.etiqueta} className="flex items-center gap-4">
              <span className="w-40 shrink-0 truncate font-display text-2xl font-semibold text-content">
                {f.etiqueta}
              </span>
              <span className="h-6 flex-1 overflow-hidden rounded-full bg-surface-sunken">
                <span
                  className="block h-full rounded-full bg-cyan transition-all duration-base"
                  style={{ width: `${(f.n / max) * 100}%` }}
                />
              </span>
              <span className="w-24 shrink-0 text-right font-display text-2xl font-bold tabular-nums text-content">
                {f.n}
                <span className="ml-2 text-lg font-normal text-content-muted">{pct}%</span>
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
